import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useSelector } from 'react-redux';
import './StoryScene.css';

const StoryScene = ({ sceneId, children, background, particles = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { currentLanguage } = useSelector((state) => state.language);
  const { scrollYProgress } = useScroll();
  
  const opacity = useTransform(scrollYProgress, [0, 0.2], [0, 1]);
  const scale = useTransform(scrollYProgress, [0, 0.3], [0.8, 1]);
  
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById(sceneId);
      if (element) {
        const rect = element.getBoundingClientRect();
        setIsVisible(rect.top < window.innerHeight * 0.8);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sceneId]);
  
  const renderParticles = () => {
    return Array.from({ length: particles }).map((_, i) => (
      <div 
        key={i} 
        className="particle"
        style={{
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`,
          animationDelay: `${Math.random() * 5}s`,
          width: `${Math.random() * 6 + 2}px`,
          height: `${Math.random() * 6 + 2}px`,
        }}
      />
    ));
  };
  
  return (
    <motion.section 
      id={sceneId}
      className={`story-scene ${currentLanguage === 'ar' ? 'rtl' : 'ltr'} ${isVisible ? 'visible' : ''}`}
      style={{ 
        background,
        opacity,
        scale,
      }}
    >
      {particles > 0 && renderParticles()}
      <div className="scene-content">
        {children}
      </div>
    </motion.section>
  );
};

export default StoryScene;